import { BaseApiUrl } from '../../../configVariables';
import {
    ConversationRatingDetailDto,
    GroundTeamRatingsSummaryResponse,
} from '../../../model/brokerConnections/IBrokerConnectionGroundTeamRatings';
import apiClient from '../../../utils/apiClient';

const groundTeamRatingsUrl = `${BaseApiUrl}/groundTeamRatings`;

export type RatingsFilterParams = {
    utcStartDate?: Date;
    utcEndDate?: Date;
    groundTeamIdFilter?: string;
    installationTeamId?: string;
};

export const getAllUserRatings = async (
    filters?: RatingsFilterParams
): Promise<GroundTeamRatingsSummaryResponse> => {
    const result = await apiClient.get<GroundTeamRatingsSummaryResponse>(
        `${groundTeamRatingsUrl}/users`,
        { query: filters }
    );
    return result.data;
};

export const getUserRatingDetails = async (
    userId: string,
    filters?: RatingsFilterParams
): Promise<ConversationRatingDetailDto[]> => {
    const response = await apiClient.get<ConversationRatingDetailDto[]>(
        `${groundTeamRatingsUrl}/users/${userId}`,
        { query: filters }
    );
    return response.data;
};
